import { render, staticRenderFns } from "./BasePopup.vue?vue&type=template&id=d35c334a&scoped=true&"
import script from "./BasePopup.vue?vue&type=script&lang=js&"
export * from "./BasePopup.vue?vue&type=script&lang=js&"
import style0 from "./BasePopup.vue?vue&type=style&index=0&id=d35c334a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35c334a",
  null
  
)

export default component.exports